import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../styles/PartsDisplayPage.css'; // Ensure this file exists for styling
import '../styles/Parts.css'; 
const PartsDisplayPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [partData, setPartData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPartData = async () => {
      try {
        const response = await axios.get(
          `/api/parts/${location.state.title}`
        );
        setPartData(response.data);
      } catch (err) {
        setError('Failed to fetch part data');
      }
    };

    if (location.state?.title) {
      fetchPartData();
    }
  }, [location.state]);

  const handleArticleClick = (articleId) => {
    navigate('/article-display', { state: { articleId } });
  };

  if (error) {
    return <div>{error}</div>;
  }

  return (
    <div className="parts-display-container">
      {partData ? (
        <div>
          <h1 className="parts-title">
            {partData.part}: {partData.title}
          </h1>
          <div className="articles-container articles-row">
            {partData.articles.map((article, index) => (
              <button
                key={index}
                className="article-button"
                onClick={() => handleArticleClick(article)}
              >
                {article}
              </button>
            ))}
          </div>
        </div>
      ) : (
        <div>Loading...</div>
      )}
    </div>
  );
};

export default PartsDisplayPage;
